export default "__VITE_ASSET__DHuXBMFn__"